import React, { Component } from 'react'

import EditableLabel from '../common/EditableLabel'
import ElementContainer from '../common/ElementContainer'
import { faMapMarkerAlt, faSpinner } from '@fortawesome/free-solid-svg-icons'

import './Address.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export default class LocationAddress extends Component {
  static weight = 1

  static defaultConfig = {
    id: 0,
    type: 'LocationAddress',
    label: 'Location Address'
  }

  static metaData = {
    icon: faMapMarkerAlt,
    displayText: 'Location Address',
    group: 'inputElement'
  }

  static configurableSettings = {
    inseeFilter: {
      default: '',
      formProps: {
        type: 'TextBox',
        label: 'Insee code filter',
        placeholder: ''
      }
    },
    geographicPriorityLat: {
      default: '',
      formProps: {
        type: 'TextBox',
        label: 'Latitude of geographic priority',
        placeholder: ''
      }
    },
    geographicPriorityLong: {
      default: '',
      formProps: {
        type: 'TextBox',
        label: 'Longitude of geographic priority',
        placeholder: ''
      }
    }
  }

  static submissionHandler = {
    findQuestionValue: (inputs, qid) => {
      let valueObject = {}
      for (const elem of inputs) {
        if (elem.q_id === qid && elem.value) {
          valueObject[elem.sub_id] = elem.value
        }
      }
      return valueObject
    }
  }
  static getPlainStringValue(entry) {
    let plainString
    if (entry.value !== '') {
      plainString = Object.entries(entry.value)
        .map(([, t]) => `${t}`)
        .filter((text) => text.trim() !== '')
        .join(' ')
    } else {
      plainString = '-'
    }
    return plainString
  }

  static renderDataValue(entry, question) {
    return (
      Object.entries(entry.value).map((entry) => {
        const key = entry[0]
        const value = entry[1]

        let defaultSublabel = true

        if (question[`${key}SublabelText`]) {
          defaultSublabel = false
        }

        return (
          <div key={key}>
            <strong
              style={defaultSublabel ? { textTransform: 'capitalize' } : null}>
              {defaultSublabel
                ? key.replace(/([a-z])([A-Z])/g, '$1 $2')
                : question[`${key}SublabelText`]}
              :
            </strong>
            {value}
            <br />
          </div>
        )
      }) || '-'
    )
  }

  static helpers = {
    getElementValue: 'defaultInputHelpers',
    isFilled: 'defaultInputHelpers'
  }

  render() {
    const { config, mode } = this.props
    const inputProps = {}

    if (typeof config.value !== 'undefined') {
      inputProps.value = config.value
    }

    if (typeof this.props.onChange !== 'undefined') {
      inputProps.onChange = this.props.onChange
    }

    if (typeof config.placeholder !== 'undefined') {
      inputProps.placeholder = config.placeholder
    }

    if (typeof config.maxLength !== 'undefined') {
      inputProps.maxLength = config.maxLength
    }
    let script

    if (mode === 'renderer') {
      const { config } = this.props
      const {
        geographicPriorityLat,
        geographicPriorityLong,
        inseeFilter
      } = config
      let scriptInnerHtml = `
     ( () => {
      const input = document.getElementById('q_${config.id}')
      const address = document.getElementById('addresses${config.id}')
      const location = document.getElementById('q_${config.id}-location')
      const spinner = document.getElementById('addressspinner${config.id}')   
      input.onkeyup = function(e) {
        if(e.target.value?.length <=  3) {
          address.innerHTML = ""
          address.className = ""
          return
        };
        spinner.classList.remove("hidden");
        let url = 'https://api-adresse.data.gouv.fr/search/?&limit=5'
        if(e.target.value) url += '&q=' + e.target.value
        if(${
          geographicPriorityLat || false
        }) url += '&lat=${geographicPriorityLat}'
        if(${
          geographicPriorityLong || false
        }) url += '&lon=${geographicPriorityLong}'
        if(${inseeFilter || false}) url += '&citycode=${inseeFilter}'
        fetch(url)
        .then(response => response.json())
          .then(res => {
            spinner.classList.add("hidden");
            let innerHtml = ""
            res.features.map((address) => {
              const point = address?.geometry || ''
              innerHtml += ('<div class="address" data-point=' + JSON.stringify(point) + '>' + address.properties.label + '</div>')
            })
            address.innerHTML = innerHtml
            address.className = "address-container"
            if(innerHtml === "") address.innerHTML = "Aucune adresse trouvée"
            const addresses = document.querySelectorAll('.address')
            addresses.forEach((addre) => {
              addre.onclick = function(e) {
                input.value = e.target.innerHTML
                const point = e.target.dataset.point
                if(point) {
                  location.value = point
                }
                address.innerHTML = ""
                address.className = ""
              }
            })
          })
          .catch(err => {
          })
      }
      
      
      })();
    `
      script = (
        <script key={5} dangerouslySetInnerHTML={{ __html: scriptInnerHtml }} />
      )
    }

    return (
      <ElementContainer type={config.type} {...this.props}>
        <div className="elemLabelTitle">
          <EditableLabel
            className="fl label"
            dataPlaceholder="Type a question"
            mode={mode}
            labelKey={config.id}
            handleLabelChange={this.props.handleLabelChange}
            value={config.label}
            required={config.required}
          />
        </div>
        <div className="fl input">
          <input
            id={`q_${config.id}`}
            name={`q_${config.id}[address]`}
            {...inputProps}
            onChange={(e) => {
              if (inputProps.onChange) inputProps.onChange(e)
            }}
          />
          <input
            id={`q_${config.id}-location`}
            name={`q_${config.id}[location]`}
            {...inputProps}
            hidden
          />
          <FontAwesomeIcon
            icon={faSpinner}
            id={`addressspinner${config.id}`}
            className={` addressspinner hidden`}
          />
          <div id={`addresses${config.id}`}></div>
        </div>
        {mode === 'viewer' ? (
          ''
        ) : (
          <div className="clearfix">
            <EditableLabel
              className="sublabel"
              dataPlaceholder="Click to edit sublabel"
              mode={mode}
              labelKey={`sub_${config.id}_address]`}
              handleLabelChange={this.props.handleLabelChange}
              value={
                typeof config.sublabelText !== 'undefined' &&
                config.sublabelText !== ''
                  ? config.sublabelText
                  : ''
              }
            />
          </div>
        )}
        <div className="fl metadata">
          <div className="requiredErrorText">{config.requiredText}</div>
        </div>
        {script && script}
      </ElementContainer>
    )
  }
}
